import * as React from 'react';

import { AmenityViewModel, RoomViewModel } from 'models';

import { UitkIconSize } from 'uitk-react-icons';

import { RoomAmenities } from 'components/infosite/rooms-and-rates/room-amenities';

export interface RoomDetailsAmenitiesProps {
  amenityItemClasses?: string;
  className?: string;
  iconSize?: UitkIconSize;
  room?: RoomViewModel;
  roomAmenities?: AmenityViewModel[];
  listClasses?: string[];
}

export const RoomDetailsAmenities: React.FunctionComponent<RoomDetailsAmenitiesProps> = ({
  amenityItemClasses,
  className,
  iconSize,
  listClasses,
  room,
  roomAmenities,
}) => {
  const amenities = roomAmenities || (room && room.roomAmenities);

  return (
    <div data-stid="content-room-amenities-grid">
      {amenities && amenities.length > 0 && (
        <RoomAmenities
          amenityItemClasses={amenityItemClasses}
          className={className}
          iconSize={iconSize}
          roomAmenities={amenities}
          listClasses={listClasses}
        />
      )}
    </div>
  );
};

RoomDetailsAmenities.displayName = 'RoomDetailsAmenities';
